
const digest = 'a631e2bc26fcc36f177bc52d492817a4c7153293b9de4625c582082a51035760';
const classes = {"quickAdjustmentWrapper":"_quickAdjustmentWrapper_axc5e_1","wrapper":"_wrapper_axc5e_1","options":"_options_axc5e_9"};
const css = `._quickAdjustmentWrapper_axc5e_1, ._wrapper_axc5e_1 {
  padding: 0 24px;
}

._wrapper_axc5e_1 {
  flex: 0 0 50%;
}

._options_axc5e_9 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  background: #f2f4f7;
  box-shadow: 0 0 0 1px #e6e7eb;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  